import { Alert, AlertVariant, Button, Flex, FlexItem, FormGroup, Modal, Page, PageSection, Spinner, TextArea, ToolbarContent, ToolbarItem } from '@patternfly/react-core';  
import React from 'react';  
import { saveTemplate } from './FlowService';
import { getCurrentADMArchive } from './utils';
  
export function LookupConfigModal({ isModal, handleModalToggle, templateId, templateData, postSaveProcess }: { isModal: boolean, handleModalToggle: () => void, templateId: string, templateData: any, postSaveProcess: any}) {  
  
    return (  
        <React.Fragment>  
            <Modal  
                width={'75%'}  
                title="Lookup Configuration"  
                isOpen={isModal}  
                onClose={handleModalToggle}  
                height={'50%'}  
            >  
                <LookupConfig templateId={templateId} data={templateData} postSaveProcess={postSaveProcess}/>  
            </Modal>  
        </React.Fragment>  
    );  
}  

const emptyGuid = '00000000-0000-0000-0000-000000000000';
    
const saveFile = (templateId: string, templateData: any, postSaveProcess: any, payload: any) => {
    return getCurrentADMArchive().then(async (value: Uint8Array | null) => {
        
        let tenantId = templateData?.tenantId;

        console.log('File data: ', value);
        if (value === null) {
            return;
        }
        const fileContent = new Blob([value], {
            type: 'application/octet-stream'
        });
        const formData = new FormData();
        let queryParam = '';
        // If tenantId is default or empty or undefined or mappingType is CUSTOM, then need to pass templateId in query param i.e create new template
        if( tenantId === emptyGuid || tenantId === '' || tenantId === undefined || templateData?.mappingType === 'CUSTOM'){  
            queryParam = templateId ? `?mappingTemplateId=${templateId}` : '';  
        }
                
        formData.append('mappingTemplateInfo', JSON.stringify({
            'name': templateData?.templateName,
            "sourceId": templateData?.sourceId,
            "sourceName": templateData?.sourceName,
            'sourceEventType': templateData?.sourceEventType,
            "sourceVersion": templateData?.sourceVersion,
            "targetId": templateData?.targetId,
            "targetName": templateData?.targetName,
            "targetVersion": templateData?.targetVersion,
            'targetEventType': templateData?.targetEventType,
            'lookupConfig': payload
        }));
        formData.append('mappingTemplateFile', fileContent, templateData?.sourceName);
        return saveTemplate(formData, queryParam)
            .then(item => {
                console.log(item);
                postSaveProcess(item);
            }).catch(error => {  
                console.error('An error occurred when saving template ', error);  
            });
    })
}

export function LookupConfig({ templateId, data , postSaveProcess}: {templateId: string, data: any , postSaveProcess: any}) {  
    const [isLoading, setIsLoading] = React.useState(false);  
    const [payload, setPayload] = React.useState(data.lookupConfig);
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => {
                setErrorMessage(null);
            }, 8000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [errorMessage]);
  
    return (  
        <React.Fragment>  
            {isLoading ? <Spinner aria-label="Loading..." /> :  
                <Page>  
                    {errorMessage && (
                        <PageSection padding={{ default: 'noPadding' }} variant='light'>
                            <Alert
                                variant={AlertVariant.danger}
                                title="Error"
                                actionClose={<button onClick={() => setErrorMessage(null)}>×</button>}
                                isInline
                            >
                                {errorMessage}
                            </Alert>
                        </PageSection>
                    )}
                    <PageSection padding={{ default: 'noPadding' }} variant='light'>  
                        <Flex>  
                            <FlexItem align={{ default: 'alignRight' }}>  
                                <ToolbarContent alignment={{ default: 'alignRight' }}>  
                                    <ToolbarItem>  
                                        <Button isDisabled={!templateId} onClick={async () => {  
                                            setIsLoading(true);
                                            setErrorMessage(null); // Clear previous errors
                                            const processedPayload = payload.trim() === '' ? null : payload;
                                            await saveFile(templateId, data, postSaveProcess, processedPayload)
                                                .catch((error) => {
                                                    // Check if it's an authorization error
                                                    if (error.message && error.message.includes('Access Denied')) {
                                                        setErrorMessage('Access Denied: You do not have sufficient permissions to save templates. Editor role is required.');
                                                    } else if (error.message && error.message.includes('permissions')) {
                                                        setErrorMessage(error.message);
                                                    } else {
                                                        setErrorMessage('An error occurred while saving the template. Please try again.');
                                                    }
                                                    console.error('Save template error:', error);
                                                });
                                            setIsLoading(false);  
                                        }}>Save</Button>  
                                    </ToolbarItem>  
                                </ToolbarContent>  
                            </FlexItem>  
                        </Flex>  
                    </PageSection>  
                    <PageSection isFilled padding={{ default: 'noPadding' }} variant='light'>  
                        <Flex>  
                            <FlexItem style={{ flex: 'auto' }}>  
                                <FormGroup label="Configuration" fieldId='config-textarea'>  
                                    <TextArea 
                                        label='Configuration' 
                                        autoResize 
                                        placeholder='Please input the configuration here' 
                                        style={{ height: '500px', width: '100%' }} 
                                        value={payload} 
                                        onChange={(value: any) => setPayload(value)} 
                                        aria-label="text area example" 
                                    />  
                                </FormGroup>  
                            </FlexItem>  
                        </Flex>  
                    </PageSection>  
                </Page>}  
        </React.Fragment>  
    );  
}